import React from 'react';
import ReactDOM from 'react-dom/client';
import ShelvingQuoteTool from './ShelvingQuoteTool';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ShelvingQuoteTool />
  </React.StrictMode>
);

